export default {
  improvement_plans_detail: {
    create_form: {
      cautions_title: '@:settings.cautions_title',
      cautions_content: '・ข้อมูลที่ต้องกรอกในแผนการปรับปรุงแสดงอยู่ใน {toCompanyName}.\n・ไฟล์แนบแสดงใน {toCompanyName} และจะแสดงเฉพาะชื่อไฟล์เท่านั้น',
    },
    chat: {
      card_title: 'ข้อความ',
      input_area_description: 'คุณสามารถส่งข้อความถึง {toCompanyName} เกี่ยวกับแผนการปรับปรุงได้',
      send_confirm: {
        modal_title: 'ตรวจสอบข้อความที่จะส่ง',
        confirm_text: 'คุณแน่ใจหรือไม่ว่าต้องการส่งข้อความนี้',
        confirm_text_near_by_check_box: 'ตรวจสอบข้อความแล้ว',
        send_button_label: '@:upload_common.send',
      },
      send_complete: {
        // toast_text:
      },
      delete_confirm: {
        modal_title: 'ลบข้อความนี้',
        confirm_text: 'คุณแน่ใจหรือไม่ว่าต้องการลบข้อความนี้',
        delete_button_label: '@:settings.button.do_delete',
      },
      log: {
        title: 'ส่งประวัติ',
        send_status: {
          success: 'ส่งแล้ว',
          failure: 'ไม่สามารถส่งได้',
        },
      },
    },
  },
}
